import { logErrorGracefully as deprecatedLogErrorGracefully } from '../deprecated/deprecated-apoly-app/utilities/failGracefully';

const message = `this error will logged gracefully. information about the error below`;

export const logErrorGracefully = (error: Error) => {
  // tslint:disable-next-line:no-console
  console.error(error, message);
  deprecatedLogErrorGracefully(error);
};
